import { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';

import { parseURL } from 'helpers/video_url_parser';
import MediaCaption from 'contentful/media_caption';
import videoPlayIcon from '../../assets/images/landers/trade_hub/video-play.png';

const FullScreenVideo = ({
  item,
  id: sectionID,
  containerClass,
  isSquare = false,
}) => {
  const [thumbSRC, setThumbSRC] = useState('');
  const [embedUrlID, setEmbedUrlID] = useState();

  const { title, link, thumbnailOnly } = item;

  const getThumb = video => {
    const videoDetails = parseURL(video);
    const videoType = videoDetails.type;
    const videoID = videoDetails.id;

    if (videoType === 'youtube') {
      setEmbedUrlID(videoID);
      setThumbSRC(`https://img.youtube.com/vi/${videoID}/maxresdefault.jpg`);
    } else if (videoType === 'vimeo') {
      axios
        .get(`https://vimeo.com/api/v2/video/${videoID}.json`)
        .then(({ data }) => {
          setEmbedUrlID(videoID);
          setThumbSRC(data[0].thumbnail_large);
        });
    }
  };

  useEffect(() => {
    if (link) {
      getThumb(link);
    }
  }, []);

  return thumbnailOnly ? (
    <div className="yt__image-wrapper">
      <a
        href={link}
        className="yt-list__item-link"
        target="_blank"
        rel="nofollow noopener noreferrer">
        <img src={thumbSRC} alt={title} className="thumb" />
        <img className="yt__play-icon" src={videoPlayIcon} alt="play video" />
      </a>
    </div>
  ) : (
    <div id={`video-player_${sectionID}`} className={containerClass}>
      <VideoWrapper isSquare={isSquare}>
        <iframe
          src={`https://www.youtube.com/embed/${embedUrlID}`}
          height="100%"
          width="100%"
          frameBorder="0"
          scrolling="no"
          title={title}
          allowFullScreen
        />
      </VideoWrapper>
      {title && <MediaCaption>{title}</MediaCaption>}
    </div>
  );
};

const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: ${({ isSquare }) =>
    isSquare ? '72.65%' : '56.25%'}; /* 16:9 */
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export default FullScreenVideo;
